import React from "react";
import PropTypes from "prop-types";

//
import { Formik } from "formik";
import * as yup from "yup";

//
import { Form, Button, Card } from "react-bootstrap";

function Password({ hideModal }) {
  /**
   * Submit Password
   */
  const submit_password = (e) => {
    console.log(e);
  };

  return (
    <div className="password">
      <Formik
        validationSchema={yup.object().shape({
          password: yup.string().required(),
        })}
        onSubmit={submit_password}
        initialValues={{
          password: "",
        }}
      >
        {({ handleSubmit, handleChange, touched, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group className="form-group" controlId="validationFormik01">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Type here..."
                className="form-control"
                onChange={handleChange}
                autoComplete="off"
                isInvalid={touched.password && !!errors.password}
              />
            </Form.Group>

            <Card className="box-alert bordered">
              <Card.Body>
                <i className="las la-info-circle"></i>
                You will permanently lose all your reviews, contacts, messages,
                and profil info. After this, there is no turning back
              </Card.Body>
            </Card>

            <div className="actions">
              <div className="back" onClick={hideModal}>
                Close
              </div>

              <Button variant="danger" size="lg" type="submit">
                Delete Account
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

Password.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default Password;
